import { Link } from 'react-router';

export type StatsCardProps = {
  label: string;
  value: string | number;
  iconSrc: string;
  /** Si está definido, la tarjeta es clicable y navega a esta ruta (p. ej. dashboard). */
  to?: string;
};

const shellClass =
  'flex items-center gap-4 rounded-xl bg-white p-4 shadow-[0_14px_32px_rgba(15,23,42,0.16)]';

const interactiveClass =
  'cursor-pointer no-underline text-inherit transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_18px_40px_rgba(15,23,42,0.22)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00356b]/30 focus-visible:ring-offset-2 active:translate-y-0';

export const StatsCard = ({ label, value, iconSrc, to }: StatsCardProps) => {
  const inner = (
    <>
      <img className="mr-2 h-12 w-12 shrink-0" src={iconSrc} alt="" />
      <div className="flex min-w-0 flex-col gap-4">
        <span className="text-[0.9rem] text-[#00356b]">{label}</span>
        <span className="text-[1.2rem] font-bold text-[#00356b]">{value}</span>
      </div>
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={`${shellClass} ${interactiveClass}`}
        aria-label={`${label}: ${value}`}
      >
        {inner}
      </Link>
    );
  }

  return <div className={shellClass}>{inner}</div>;
};
